"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("@Components/Buttons/Button");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const ViewWorkHeader_1 = __importDefault(require("@Components/ViewWork/Headers/ViewWorkHeader"));
const WorkDraftHeader = (props) => {
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    return (react_1.default.createElement(ViewWorkHeader_1.default, { work: props.work },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'sub-data' },
                react_1.default.createElement("div", null,
                    "Last Edited:",
                    react_1.default.createElement("span", { className: 'bold' }, props.work.updateDate &&
                        new Date(props.work.updateDate).toLocaleString('default', {
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric',
                        })))),
            react_1.default.createElement(Button_1.Button, { linkOnClick: props.editOnClick, mainColor: true, type: 'primary-small', linkTo: navigation_1.default.rightholder.registrationDrafts.editRoot(rightsholderStore.currentRightsholderId, 'draft', props.work.id), typeLink: true }, "Edit"))));
};
exports.default = WorkDraftHeader;
